import { createPortal } from "react-dom";
import OnboardingProgress from "./OnboardingProgress";
import WelcomeStep from "./steps/WelcomeStep";
import CreateNoteStep from "./steps/CreateNoteStep";
import ExploreMapStep from "./steps/ExploreMapStep";

const STEP_COMPONENTS = {
  welcome: WelcomeStep,
  createNote: CreateNoteStep,
  exploreMap: ExploreMapStep,
};

export default function OnboardingOverlay({
  currentStep,
  currentStepIndex,
  totalSteps,
  onNext,
  onSkip,
  onBack,
  onComplete,
  onCreateNote,
  onGoToStep,
}) {
  const StepComponent = STEP_COMPONENTS[currentStep];
  if (!StepComponent) return null;

  const showBack = currentStepIndex > 0;

  // Step 3 (exploreMap) uses a lighter backdrop so the map is more visible
  const isMapStep = currentStep === "exploreMap";

  const stepProps = {
    welcome: { onNext, onSkip, onBack, showBack },
    createNote: { onCreateNote, onSkip, onBack, showBack },
    exploreMap: { onComplete, onBack, showBack },
  };

  const overlay = (
    <div
      className={`fixed inset-0 z-[55] flex items-center justify-center p-4 ${
        isMapStep ? "bg-black/40" : "bg-black/60"
      }`}
    >
      <div className="w-full max-w-sm rounded-2xl bg-surface-elevated/95 backdrop-blur-sm border border-white/10 shadow-2xl p-8">
        <StepComponent {...stepProps[currentStep]} />

        {/* Progress dots */}
        {totalSteps > 1 && (
          <div className="flex justify-center mt-6">
            <OnboardingProgress
              currentIndex={currentStepIndex}
              total={totalSteps}
              onGoToStep={onGoToStep}
            />
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
}
